import Cookies from 'js-cookie';
import * as utils from './Utils';
import * as shopwareUtils from './Shopware';
import * as constants from 'common/constants';


export function allowCookieId() {
  let platform = utils.getEcommercePlatform();
  if (platform === 'shopware') return shopwareUtils.allowCookieId();
  return true;
}

export function allowContactIdCookie() {
  let platform = utils.getEcommercePlatform();
  if (platform === 'shopware') return shopwareUtils.allowContactIdCookie();
  return true;
}

export function allowBackInStockVisitorIdCookie() {
  let platform = utils.getEcommercePlatform();
  if (platform === 'shopware') return shopwareUtils.allowBackInStockVisitorIdCookie();
  return true;
}

export function allowReviewsUpvotedCookie() {
  let platform = utils.getEcommercePlatform();
  if (platform === 'shopware') return shopwareUtils.allowReviewsUpvotedCookie();
  return true;
}

export function allowPromptSessionCookies() {
  let platform = utils.getEcommercePlatform();
  if (platform === 'shopware') return shopwareUtils.allowPromptSessionCookies();
  return true;
}

export function allowPromptVisitorIdCookie() {
  let platform = utils.getEcommercePlatform();
  if (platform === 'shopware') return shopwareUtils.allowPromptVisitorIdCookie();
  return true;
}

export function allowPromptLastSeenCookie() {
  let platform = utils.getEcommercePlatform();
  if (platform === 'shopware') return shopwareUtils.allowPromptLastSeenCookie();
  return true;
}

//======================================
// Core Functions
//======================================
export function canSetCookie(name) {
  if (name === constants.COOKIE_ID) return allowCookieId();
  if (name === constants.COOKIE_CONTACT_ID) return allowContactIdCookie();
  if (name === constants.COOKIE_REVIEWS_UPVOTED) return allowReviewsUpvotedCookie();
  if (name === constants.COOKIE_BACKINSTOCK_VISITOR_ID) return allowBackInStockVisitorIdCookie();

  if (name.startsWith("ov_prompt_session")) return allowPromptSessionCookies();
  if (name === constants.COOKIE_PROMPT_VISITOR_ID) return allowPromptVisitorIdCookie();
  if (name === constants.COOKIE_PROMPT_LAST_SEEN) return allowPromptLastSeenCookie();
  return true;
}

export function getCookie(...args) {
  return utils.getCookie(...args);
}

export function setCookie(name, value, attributes={}) {
  if (!canSetCookie(name)) return;

  if (!('expires' in attributes)) {
    attributes['expires'] = constants.COOKIE_EXPIRES_DAYS;
  }

  Cookies.set(name, value, attributes);
  return Cookies.get(name, attributes);
}

export function setSessionCookie(name, value, attributes={}) {
  if (!canSetCookie(name)) return;
  Cookies.set(name, value, attributes);
  return Cookies.get(name, attributes);
}

export function getOrSetCookie(name, value, attributes={}) {
  const cookie = getCookie(name, attributes) || null;
  if (cookie) return cookie;
  if (!canSetCookie(name)) return;

  if (!('expires' in attributes)) {
    attributes['expires'] = constants.COOKIE_EXPIRES_DAYS;
  }

  setCookie(name, value, attributes);
  return getCookie(name, attributes);
}

export function removeCookie(name, attributes={}) {
  Cookies.remove(name, attributes);
}

export function getCookieInt(cookieName) {
  let value = 0;

  try {
    value = parseInt(getCookie(cookieName)) || 0;
  } catch(e) {
    value = 0;
  }

  return value;
}

export function parseCookieJson(rawValue, defaultValue) {
  let value = defaultValue;
  if (rawValue) {
    try {
      value = JSON.parse(rawValue);
    } catch(e) {
      value = defaultValue;
    }
  }

  if (!rawValue) value = defaultValue;
  return value;
}

//======================================
// Get Cookies
//======================================
export function getCookieId() {
  const cookieName = constants.COOKIE_ID;
  let cookieValue = getCookie(cookieName);
  return cookieValue;
}

export function getOrCreateCookieId() {
  let cookieValue = getCookieId();
  if (cookieValue) return cookieValue;

  const cookieName = constants.COOKIE_ID;
  if (!canSetCookie(cookieName)) return;

  cookieValue = utils.uniqueId();
  setCookie(cookieName, cookieValue);
  return cookieValue;
}

export function getContactId() {
  const cookieName = constants.COOKIE_CONTACT_ID;
  let cookieValue = getCookie(cookieName);
  return cookieValue;
}
